import React from "react";
import image from "./advancedAccuracy.svg";
import { FormattedMessage } from "react-intl";
import {
  BottomButton,
  BottomButtonContainer,
} from "../../../elements/wrapper/bottomButton.wrapper.jsx";
import { getQueryParams } from "../../../../app/RouteWithSubRoutes";
import StandardHeadline from "../../../elements/text/standardHeadline.text.jsx";
import IntroImage from "../../introImage.component.jsx";
import StandardInstruction from "../../../elements/text/standardInstruction.component.jsx";
import ToggleSetting from "../../../elements/buttons/toggleSetting.component.jsx";
import { pageNames } from "../../../../reduxStore/reducers/main.js";
import { useNativePermissionCheck } from "../../../nativeAppInterface/sideEffects/useNativePermissionCheck.js";
import { useHealthStatsPermissionCall } from "../../../nativeAppInterface/sideEffects/useHealthStatsPermissionCall.js";

/**
 * Die LocationAbfrage im Intro
 * @param userAllowedGPS
 * @param setUserAllowedGPS
 * @param locationPermissionAllowed
 * @param setGPSData
 * @param history
 * @param setLocationPermissionAllowed
 * @param isApp
 * @param match
 * @return {JSX.Element}
 * @constructor
 */
export default function HealthStats({ properties, history, setProperties }) {
  const handleClickNext = () => {
    if (!properties.healthStats.userAllowed) {
      setProperties({
        healthStats: { userAllowed: false },
      });
    }
    history.push(
      `/${pageNames.intro}/${pageNames.selectRestrictions}/${getQueryParams()}`
    );
  };

  const onToggle = () => {
    setProperties({
      healthStats: { userAllowed: !properties.healthStats.userAllowed },
    });
  };

  const { error } = useNativePermissionCheck(
    properties.healthStats.userAllowed,
    properties.healthStats.permissionAllowed
  );

  useHealthStatsPermissionCall(properties, setProperties);

  return (
    <BottomButtonContainer
      buttons={[
        new BottomButton(
          () => history.goBack(),
          <FormattedMessage id={"search.buttonBack"} />,
          {
            className: "mr-3 normalButton--naked",
            disabled: error,
          }
        ),
        new BottomButton(
          handleClickNext,
          <FormattedMessage id="welcome.next" />,
          {
            disabled: error,
            loading: true,
            className: "normalButton--primary",
          }
        ),
      ]}
    >
      <IntroImage fallbackImage={image} imageName={"advancedAccuracy.svg"} />
      <div className="pl-3 pr-3">
        <StandardHeadline className={"mb-2 mt-3"} type={"h2"}>
          <FormattedMessage id="welcome.healthStats.headline" />
        </StandardHeadline>
        <StandardInstruction className={"mb-4"} type={"p"}>
          <FormattedMessage id="welcome.healthStats.text" />
        </StandardInstruction>
        <div className="d-flex justify-content-between pl-3 pr-3 w-100">
          <ToggleSetting
            toggleValue={!!properties.healthStats.userAllowed}
            onChange={onToggle}
            settingText={
              <FormattedMessage id="welcome.healthStats.toggle.text" />
            }
          />
        </div>
        {error && (
          <p>
            <FormattedMessage id="welcome.healthStats.toggle.noPermissionError" />
          </p>
        )}
      </div>
    </BottomButtonContainer>
  );
}
